<template>
  <span>
    <covers-content></covers-content>
  </span>
</template>

<script>
import CoversContent from "@/components/Publications/CoversContent";
export default {
  name: "Covers",
  components: {
    CoversContent
  }
};
</script>